export const APP_BAR_HEIGHT = 56
export const CHAT_LIST_APP_BAR_HEIGHT = 56
